import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Lead } from '../..//style';
import Block from '../Block';

const Container = styled(Block)`
  ${(props) => props.theme.type.notice};
`;
const Wrap = styled(Lead)`
  text-align: inherit;
`;

const Notice = ({ children, action, ...props }) => (
  <Container {...props}>
    <Wrap>{children}</Wrap>
    {action}
  </Container>
);
Notice.propTypes = {
  children: PropTypes.element,
  action: PropTypes.element
};
Notice.defaultProps = {
  children: null,
  action: null
};

export default Notice;
